export default __webpack_public_path__ + "static/media/CEDES-01.63243c9c.jpg";